function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M256.008 457.217L41.4266 242.64C-13.8107 187.399 -13.8097 97.5181 41.4286 42.2799C68.1885 15.52 103.767 0.783173 141.609 0.783173C179.453 0.783173 215.031 15.52 241.79 42.2799L255.999 56.4885L270.208 42.2799C296.966 15.52 332.545 0.783173 370.388 0.783173C408.231 0.783173 443.809 15.52 470.569 42.2789C525.807 97.5181 525.808 187.399 470.571 242.64L256.008 457.217Z",
  fill: "#da6551"
});

function SvgHeartInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 458,
    viewBox: "0 0 512 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHeartInline;